// Carries the optional reason typed in a delete confirmation over to the
// delete request that follows it, so every delete button does not need to be
// rewired to pass it along. Short-lived on purpose: a reason is only attached
// to a request made right after it was typed.
const MAX_AGE_MS = 15000;

let pending = { reason: "", at: 0 };

export const setDeleteReason = (reason) => {
  pending = { reason: String(reason || "").trim(), at: Date.now() };
};

export const takeDeleteReason = () => {
  const { reason, at } = pending;
  pending = { reason: "", at: 0 };
  return reason && Date.now() - at < MAX_AGE_MS ? reason : "";
};

// Deletes that move something to the Archive.
export const isArchivingRequest = (method, url) => {
  const verb = String(method || "").toUpperCase();
  const path = String(url || "");
  return verb === "DELETE" || path.includes("bulk-delete") || path.includes("mux/close");
};

export const DELETE_REASON_HEADER = "x-delete-reason";
